//
// Card
//
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Card = function Card(props) {
  const {
    className,
    children = null,
    noPadding,
    id,
    header,
  } = props;

  // With a header, the white framed box starts below it so the page shows between
  // the tabs; the body keeps the layout the card gives its children without one.
  // The wrapper clips nothing, so as a flex item it must be told it may shrink
  // below its content, which the clipping box does on its own
  if (header) {
    return (
      <div id={id} className={classNames('flex flex-col min-h-0 min-w-0', className)}>
        {header}
        <div
          className={classNames(
            'bg-white relative rounded-b-xl rounded-tr-xl border border-pxMainOutline shadow-card overflow-hidden',
            'flex-1 min-h-0 flex flex-col items-stretch',
            {
              'p-2': !noPadding,
            },
          )}
        >
          {children}
        </div>
      </div>
    );
  }

  return (
    <div
      id={id}
      className={classNames(
        'bg-white relative rounded-xl border border-pxMainOutline shadow-card overflow-hidden',
        {
          'p-2': !noPadding,
        },
        className,
      )}
    >
      {children}
    </div>
  );
};

Card.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  noPadding: PropTypes.bool,
  id: PropTypes.string,
  // A CardHeader (or a row holding one), drawn above the white box with the page behind it
  header: PropTypes.node,
};

export default Card;
